import AddUserPage from "../../component/users/dynamic-users/AddUser"

 
function EditUser() {
  return (
    <div className="page-body"><AddUserPage/></div>
  )
}

export default EditUser